import * as ThemingConst from './../../const/theming';

const findLink = (link: string, head: HTMLHeadElement): HTMLLinkElement => { 
    let links = head.getElementsByTagName('link');
    let foundLink: HTMLLinkElement;
    for (let i = 0; i < links.length; i++) {
        let href_iteration = links[i].href;
        if (href_iteration.includes(link)) {
            foundLink = links[i];
            break;
        }
    }
    return foundLink;
}

export default abstract class Theming {

    static appendLinksToHead = (hrefs: Array<string>, head: HTMLHeadElement, prefix: string = '') => {    

        hrefs.forEach(href => {
            const existing = findLink(href, head);
            if (existing) {
                existing.disabled = false;
            } else {
                let theme = document.createElement('link');
                theme.setAttribute('rel', 'stylesheet');
                theme.setAttribute('type', 'text/css');
                theme.setAttribute('href', prefix + href);
                head.appendChild(theme);
            }
        });
    }
    
    static disableLinksOnHead = (href: Array<string>, head: HTMLHeadElement) => {
        let links = head.getElementsByTagName('link');
        for (let i = 0; i < links.length; i++) {
            let href_iteration = links[i].href;
            for (let a = 0; a < href.length; a++) {
                if (href_iteration.includes(href[a])) {
                    links[i].disabled = true;
                }
            }
        }
    }

        static appendThemeFile = (lightThemePaths: Array<string> = [], darkThemePaths: Array<string> = [], prefix: string = '') => {

        if (localStorage.getItem(ThemingConst.DarkThemeKey)) {
            Theming.appendLinksToHead(localStorage.getItem(ThemingConst.DarkThemeKey) === 'true'
                ? [...darkThemePaths.concat(ThemingConst.FilePaths.DarkTheme)]
                : [...lightThemePaths.concat(ThemingConst.FilePaths.LightTheme)], document.head, prefix);
        }
    }

    static getTheme = (): string => {
        let ls: string = localStorage.getItem(ThemingConst.DarkThemeKey);
        if (ls) {
            return ls === 'true' ? 'dark' : 'light';
        }
        else {
            return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }
    } 

    static cssVarToHex = (cssVar: string): string => {
        // Get hsl value from CssVar
        let computedStyle: CSSStyleDeclaration = getComputedStyle(document.documentElement),
            lightnessEvaluation: string = computedStyle.getPropertyValue(cssVar).replace(/[a-z]|\s|\(|\)|\%|\'/g, '').split(',')[2];
        
        let evalCssVar = (cssVar: string, trimPercentage: boolean = true) : number => {
            let value: string = computedStyle.getPropertyValue(cssVar);
            return trimPercentage ? Number(value.split('').filter(l => l !== '%').join('')) : Number(value);
        }

        let h: number = evalCssVar('--bg-h', false),
            s: number = evalCssVar('--bg-s'),
            l: number = eval(lightnessEvaluation);       

        // Convert hsl to hex
        s /= 100;
        l /= 100;
        let c: number = (1 - Math.abs(2 * l - 1)) * s,
            x: number = c * (1 - Math.abs((h / 60) % 2 - 1)),
            m: number = l - c / 2,
            r: number = 0,
            g: number = 0,
            b: number = 0;
        if (0 <= h && h < 60) {
            r = c; g = x; b = 0;
        } else if (60 <= h && h < 120) {
            r = x; g = c; b = 0;
        } else if (120 <= h && h < 180) {
            r = 0; g = c; b = x;
        } else if (180 <= h && h < 240) {
            r = 0; g = x; b = c;
        } else if (240 <= h && h < 300) {
            r = x; g = 0; b = c;
        } else if (300 <= h && h < 360) {
            r = c; g = 0; b = x;
        }
        let rh: string, gh: string, bh: string;
        rh = Math.round((r + m) * 255).toString(16);
        gh = Math.round((g + m) * 255).toString(16);
        bh = Math.round((b + m) * 255).toString(16);
        if (rh.length == 1)
            rh = '0' + r;
        if (gh.length == 1)
            gh = '0' + g;
        if (bh.length == 1)
            bh = '0' + b;
        return '#' + rh.toUpperCase() + gh.toUpperCase() + bh.toUpperCase();
    }

    static getRelativePath = (source, target) => {
        var sep = (source.indexOf("/") !== -1) ? "/" : "\\",
            targetArr = target.split(sep),
            sourceArr = source.split(sep),
            filename = targetArr.pop(),
            targetPath = targetArr.join(sep),
            relativePath = "";
        
        while (targetPath.indexOf(sourceArr.join(sep)) === -1) {
            sourceArr.pop();
            relativePath += ".." + sep;
        }
        
        var relPathArr = targetArr.slice(sourceArr.length);
        relPathArr.length && (relativePath += relPathArr.join(sep) + sep);
        
        return relativePath + filename;
    }

    static toggleThemeFiles = () => {       
        if (localStorage.getItem(ThemingConst.DarkThemeKey)) {
            const isDark = localStorage.getItem(ThemingConst.DarkThemeKey) === 'true';
            Theming.disableLinksOnHead([isDark ? ThemingConst.FilePaths.LightTheme :  ThemingConst.FilePaths.DarkTheme], document.head);
            Theming.appendLinksToHead(isDark ? [ThemingConst.FilePaths.DarkTheme] : [ThemingConst.FilePaths.LightTheme], document.head);
        } else {
            Theming.disableLinksOnHead([ThemingConst.FilePaths.LightTheme, ThemingConst.FilePaths.DarkTheme], document.head);
        }
    }
}